import {
  SortOrder,
  Platform as GraphQLPlatform,
} from '@moonpig/web-explore-types-graphql'
import { type Platform } from '@moonpig/web-core-types'
import { PageTypeEnum } from '@moonpig/web-shared-products'
import { ServiceOptions } from '../types/serviceOptions'

export type LoadOptionsProps = {
  pageType: PageTypeEnum
  query: { [key: string]: string | string[] | undefined }
  platform: Platform
  department: string
}

export const loadOptions: (props: LoadOptionsProps) => ServiceOptions = ({
  pageType,
  query,
  platform,
  department,
}) => {
  const payPerClickFiltering = (query['only-ppc-results'] as string) === 'true'

  const shouldReturnSuggestions =
    pageType === PageTypeEnum.SEARCH || pageType === PageTypeEnum.DYNAMIC

  const shouldReturnRecommendations =
    pageType === PageTypeEnum.GALLERY && department === 'ALL_CARDS'

  return {
    payPerClickFiltering,
    platform: platform.isMobile
      ? GraphQLPlatform.MOBILE_WEB
      : GraphQLPlatform.WEB,
    defaultSortOrder: SortOrder.POPULARITY,
    shouldReturnSuggestions,
    shouldReturnRecommendations,
  }
}
